import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { BaseApiTemplateService } from '../../../shared/base-api-template-service.model';
import { Core2Config } from '../../../shared/core2Config';
import { JobHeaderContainerModel } from '../../../../../../../models/aggregates/erp/delivery/job';
import { ApiVisa } from '../../../shared';
import { Observable } from 'rxjs';
import { Pagination, PagingResponseModel, BasicApiResponseModel } from './../../../shared';
import { ApiResponseModel } from '../../../shared/api-response.model';


@Injectable({
  providedIn: 'root'
})
export class JobHdrService extends BaseApiTemplateService<JobHeaderContainerModel> {
  // https://api-test.akaun.com/core2/tnt/dm/del/jobs
  readonly url = Core2Config.DOMAIN_TEST_URL + Core2Config.TENANT_DOMAIN_URL_PREFIX + 'del/jobs';
  constructor(http: HttpClient) {
    super();
    this.apiUrl = Core2Config.DOMAIN_TEST_URL + Core2Config.TENANT_DOMAIN_URL_PREFIX + 'del/jobs';
    this.endpoint_path = Core2Config.TENANT_DOMAIN_URL_PREFIX + 'del/jobs';
    this.endpoint_path_login_url = Core2Config.TENANT_DOMAIN_URL_PREFIX + 'del/jobs/' + BaseApiTemplateService.LOGIN_ENTITY_EP;
    this.endpoint_path_login_entity_url = Core2Config.TENANT_DOMAIN_URL_PREFIX + 'del/jobs/' + BaseApiTemplateService.LOGIN_EP;
    this.endpoint_path_public_url = Core2Config.TENANT_DOMAIN_URL_PREFIX + 'del/jobs/' + BaseApiTemplateService.BACKOFFICE_EP;
    this.httpClient = http;
  }

  public getByGuidLoginEP(
    guid: string,
    visa: ApiVisa
  ): Observable<BasicApiResponseModel<any>> {
    if (this.endpoint_path_login_url && visa.api_domain_url) {
      this.apiUrl = visa.api_domain_url + this.endpoint_path_login_url;
    }
    return this.httpClient.get<BasicApiResponseModel<any>>(
      this.apiUrl + '/' + guid,
      this.getHttpHeader(visa)
    );
  }

  public getByCriteria(
    pagination: Pagination,
    visa: ApiVisa,
    criteria?: any,
  ): Observable<PagingResponseModel<any>> {
    // console.log('get by criteria bsae-api');
    if (this.endpoint_path_public_url && visa.api_domain_url) {
      this.apiUrl = visa.api_domain_url + this.endpoint_path_public_url;
    }
    const UrlByCriteria =
      this.apiUrl + '/query?' + pagination.getQueryKeyValues();
    return this.httpClient.get<PagingResponseModel<any>>(
      UrlByCriteria,
      this.getHttpHeader(visa)
    );
  }

  public getByCriteriaLoginEP(
    pagination: Pagination,
    visa: ApiVisa,
    criteria?: any,
  ): Observable<PagingResponseModel<any>> {
    // console.log('get by criteria bsae-api');
    // /core2/tnt/dm/del/jobs/login-ep/query
    if (this.endpoint_path_login_entity_url && visa.api_domain_url) {
      this.apiUrl = visa.api_domain_url + this.endpoint_path_login_entity_url;
    }
    const UrlByCriteria =
      this.apiUrl + '/query?' + pagination.getQueryKeyValues();
    return this.httpClient.get<PagingResponseModel<any>>(
      UrlByCriteria,
      this.getHttpHeader(visa)
    );
  }

  addFiles(formData: FormData, hdrGuid: string, visa: ApiVisa) {
    let url = this.apiUrl + '/add-files/' + hdrGuid;
    if (this.endpoint_path && visa.api_domain_url) {
      url = visa.api_domain_url + this.endpoint_path + '/add-files/' + hdrGuid;
    }
    return this.httpClient.put(url, formData, this.getHttpHeader(visa));
  }

  replaceFile(formData: FormData, extGuid: string, visa: ApiVisa) {
    let url = this.apiUrl + '/replace-file/' + extGuid;
    if (this.endpoint_path && visa.api_domain_url) {
      url = visa.api_domain_url + this.endpoint_path + '/replace-file/' + extGuid;
    }
    return this.httpClient.put(url, formData, this.getHttpHeader(visa));
  }

  deleteFile(extGuid: string, visa: ApiVisa) {
    let url = this.apiUrl + '/file/' + extGuid;
    if (this.endpoint_path && visa.api_domain_url) {
      url = visa.api_domain_url + this.endpoint_path + '/file/' + extGuid;
    }
    return this.httpClient.delete(url, this.getHttpHeader(visa));
  }

  getFile(extGuid: string, visa: ApiVisa): Observable<Blob> {
    let url = this.apiUrl + '/file/' + extGuid;
    if (this.endpoint_path && visa.api_domain_url) {
      url = visa.api_domain_url + this.endpoint_path + '/file/' + extGuid;
    }
    return this.httpClient.get<Blob>(url, this.getHttpHeaderBlob(visa));
  }

  getFileLoginEP(extGuid: string, visa: ApiVisa): Observable<Blob> {
    let url = this.apiUrl + '/file/' + extGuid;
    if (this.endpoint_path_login_url && visa.api_domain_url) {
      url = visa.api_domain_url + this.endpoint_path_login_url + '/file/' + extGuid;
    }
    return this.httpClient.get<Blob>(url, this.getHttpHeaderBlob(visa));
  }

  printMultiJasperJobShipment(formatGuid: string, visa: ApiVisa, body: any) {
    let url = this.apiUrl + '/shipment/batch-print-jasper-pdf/backoffice-ep?printableFormatHdrGuid=' + formatGuid;
    if (this.endpoint_path && visa.api_domain_url) {
      url = visa.api_domain_url + this.endpoint_path + '/shipment/batch-print-jasper-pdf/backoffice-ep?printableFormatHdrGuid=' + formatGuid;
    }
    return this.httpClient.post(url, body, this.getHttpHeaderBlob(visa))
  }

  printMultiJasperGenDocJob(formatGuid: string, visa: ApiVisa, body: any) {
    let url = this.apiUrl + '/gen-doc-job/batch-print-jasper-pdf/backoffice-ep?printableFormatHdrGuid=' + formatGuid;
    if (this.endpoint_path && visa.api_domain_url) {
      url = visa.api_domain_url + this.endpoint_path + '/gen-doc-job/batch-print-jasper-pdf/backoffice-ep?printableFormatHdrGuid=' + formatGuid;
    }
    return this.httpClient.post(url, body, this.getHttpHeaderBlob(visa))
  }

  updateJobSequence(payload:any, visa:ApiVisa){
    let url = ''
    if(this.endpoint_path && visa.api_domain_url){
      url = visa.api_domain_url+ this.endpoint_path+'/backoffice-ep/update-job-sequence-in-trips'
    }
    return this.httpClient.put(url, payload, this.getHttpHeader(visa))
  }

  public getJobHdrsByTripGuidsPost(dtoObject: any, visa: ApiVisa): Observable<ApiResponseModel<any>> {
    let url;
    if (this.endpoint_path_public_url && visa.api_domain_url) {
      url = visa.api_domain_url + this.endpoint_path_public_url + '/job-hdr-listings/query';
    }
    return this.httpClient.post<ApiResponseModel<any>>(
      url,
      dtoObject,
      this.getHttpHeader(visa)
    );
  }

  printMultiJasperJobShipmentCustom(formatGuid: string, visa: ApiVisa, body: any) {
    let url = this.apiUrl + '/shipment/batch-print-jasper-pdf/custom/backoffice-ep?printableFormatHdrGuid=' + formatGuid;
    if (this.endpoint_path && visa.api_domain_url) {
      url = visa.api_domain_url + this.endpoint_path + '/shipment/batch-print-jasper-pdf/custom/backoffice-ep?printableFormatHdrGuid=' + formatGuid;
    }
    return this.httpClient.put(url, body, this.getHttpHeaderBlob(visa))
  }
}